export const DEFAULT_COLUMNS = [
  "channel",
  "product_hierarchy",
  "total_spend",
  "total_revenue",
  "total_roi",
  "total_roas",
  "total_units",
];
